var $58dcd6b47d35b105$exports = {};
$58dcd6b47d35b105$exports = {
    "more": `Ve\u{10D} elementov`
};


export {$58dcd6b47d35b105$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
